import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { Location } from "@angular/common";

@Component({
  selector: "app-dados-credor",
  templateUrl: "./dados-credor.component.html",
  styleUrls: ["./dados-credor.component.scss"],
})
export class DadosCredorComponent {
  constructor(private location: Location) {}
  @Input() formEmpresa: FormGroup;
  @Input() titulo: string = '3 - Dados do Credor Pessoa Jurídica';
  @Input() mostrarBotaoVoltar: boolean = false;

  @Output() adicionarEmpresa = new EventEmitter<void>();
  @Output() removerEmpresa = new EventEmitter<number>();
  @Output() voltar = new EventEmitter<void>();
  @Output() efetuarCadastro = new EventEmitter<void>();


  get empresasPJ(): FormArray {
    return this.formEmpresa.get("empresas") as FormArray;
  }

  getRepresentantes(empresaIndex: number): FormArray {
    return this.empresasPJ.at(empresaIndex).get("representantes") as FormArray;
  }
}
